<script>
import { Line } from 'vue-chartjs';
import { getTooltipTitle } from './helpers/chart-timestamp';
import Moment from 'moment';

export default {
  extends: Line,
  props: {
    accelarationData: {
      type: Array,
    },
    speedData: {
      type: Array,
    },
    offset: {
      type: Number,
    },
  },
  data() {
    let vm = this;
    return {
      chartData: {
        datasets: [
          {
            data: this.speedData,
            fill: true,
            borderColor: '#FD4747',
            backgroundColor: 'rgba(253, 71, 71, 0.1)',
            borderWidth: 1,
            pointRadius: 0,
            tension: 0,
          },
          {
            data: this.accelarationData,
            fill: true,
            borderColor: '#A074FF',
            backgroundColor: 'rgba(160, 116, 255,0.2)',
            borderWidth: 1,
            pointRadius: 0,
            tension: 0,
          },
        ],
      },
      options: {
        tooltips: {
          mode: 'x',
          intersect: false,
          enabled: true,
          callbacks: {
            title: function(tooltipItems) {
              return getTooltipTitle(tooltipItems, vm.offset);
            },
            label: function() {
              return '';
            },
          },
        },

        hover: {
          mode: 'nearest',
          intersect: true,
          onHover: function() {
            if (
              this.chart.tooltip._active &&
              this.chart.tooltip._active.length
            ) {
              var activePoint = this.chart.tooltip._active[0],
                ctx = this.chart.ctx,
                x = activePoint.tooltipPosition().x,
                topY = this.chart.scales['y-axis-0'].top,
                bottomY = this.chart.scales['y-axis-0'].bottom;

              ctx.save();
              ctx.beginPath();
              ctx.moveTo(x, topY);
              ctx.lineTo(x, bottomY);
              ctx.lineWidth = 1;
              ctx.strokeStyle = '#45171d';
              ctx.stroke();
              ctx.restore();
            }
          },
          animationDuration: 0,
          // onHover: (e, element) => this.passEvent(e, element),
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: false,
                display: false,
              },
              gridLines: {
                color: 'rgba(0, 0, 0, 0)',
              },
              scaleLabel: {
                display: true,
                fontSize: 12,
                fontColor: '#8D8D8D',
                fontStyle: 'bold',
                labelString: 'Speed & Acceleration',
              },
              labels: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                fontSize: 12,
                fontColor: '#8D8D8D',
                fontStyle: 'bold',
                labelString: `Time (${new Moment()
                  .utcOffset(this.offset)
                  .format('Z')} GMT)`,
              },
              gridLines: {
                color: false,
              },
              type: 'time',
              time: {
                parser: 'HH:mm:ss',
                unit: 'minute',
                displayFormats: {
                  minute: 'HH:mm:ss',
                  hour: 'HH:mm:ss',
                },
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
</script>
